import { fromDate, getLocalTimeZone } from "@internationalized/date";
import { TrainInformationDetailedResponse } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/responseSchema";
import { countryCodeSchema } from "features/VehicleSidebar/VehicleList/TrainList/types";
import { z } from "zod";

export const productionDeviationSchema = z.object({
  reference: z.string(),
  countryCode: countryCodeSchema,
  trainIds: z.string().array(),
  fromDate: z.coerce
    .date()
    .transform((time) => fromDate(time, getLocalTimeZone())),
  toDate: z.coerce
    .date()
    .transform((time) => fromDate(time, getLocalTimeZone())),
  eventType: z.string(),
  reasonType: z.string(),
  updatedAt: z.coerce
    .date()
    .transform((time) => fromDate(time, getLocalTimeZone())),
});

export type ProductionDeviationResponse = z.infer<
  typeof productionDeviationSchema
>;

export const productionDeviationDetailedSchema = productionDeviationSchema.and(
  z.object({
    trainEvents: z.custom<TrainInformationDetailedResponse>().array(),
  }),
);

export type ProductionDeviationDetailedResponse = z.infer<
  typeof productionDeviationDetailedSchema
>;
